/* eslint-disable */
import React from "react";

import { Fade, Reveal } from "react-awesome-reveal";
import {
  fadeInDownShorter,
  fadeInLeft,
  fadeInRight,
  fadeInUp,
} from "./animation";

import { about } from "../prime";

function About() {
  return (
    <div id="about" className=" px-1 py-1 lg:px-10 lg:py-5">
      <div className="shrink w-120 flex-col items-center justify-center  mt-5">
        <div className="flex flex-col items-center justify-center">
          <Reveal keyframes={fadeInDownShorter} duration={1000} delay={500}>
            <h1 className="text-3xl lg:text-6xl font-bold tracking-tight text-center lg:text-center mt-16 lg:mt-40">
              About Us
            </h1>
          </Reveal>
          <Reveal keyframes={fadeInDownShorter} duration={1000} delay={700}>
            <p className="my-5 text-lg lg:text-xl leading-8 px-5 lg:px-10 text-gray-300 opacity-75 text-center lg:text-center">
            Kaafila is a blockchain project with a focus on education and digital media, and Kaafila Metaverse aims to help millions of Users with virtual learning and virtual working.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="flex flex-row mt-5 lg:mt-32 mb-20 px-3 py-5 lg:px-5 lg:py-6 ">
        <div className="w-[44%] hidden lg:block">
          <div className="relative h-[700px] w-full overflow-hidden  ">
            <Reveal keyframes={fadeInDownShorter} duration={1000} delay={500}>
              <img
                className="p-2 cover-fit rounded-2xl "
                src=" "
              />
            </Reveal>
          </div>
        </div>

        <div className="flex-1  py-10 px-7 lg:py-10 lg:px-12 tracking-wide rounded-xl bg-[#ffffff10] hover:bg-[#ffffff27]  ">
          <Reveal keyframes={fadeInDownShorter} duration={1000} delay={500}>
            <p className="font-bold text-3xl mb-10"> {about.title}</p>
          </Reveal>

          <Reveal keyframes={fadeInDownShorter} duration={1000} delay={400}>
            <p className="font-medium  text-[14px] lg:text-lg py-6 opacity-50 hover:opacity-75 ">
              {about.content1}
            </p>

            <p className="font-medium text-[14px] lg:text-lg py-6 opacity-50 hover:opacity-75">
              {about.content2}
            </p>

            <p className="font-medium text-[14px] lg:text-lg py-6 opacity-50 hover:opacity-75">
              {about.content3}
            </p>
          </Reveal>
          <Reveal keyframes={fadeInDownShorter} duration={1000} delay={500}>
        
            <a href="https://kaafila.org/pitchdeck.pdf" class="mr-9 text-neutral-800 dark:text-neutral-200">
            <svg class="h-8 w-8 text-black-500"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/>
</svg>

              
              </a>
          
          </Reveal>
        </div>
      </div>
    </div>
  );
}

export default About;
